var map = {
	"./aiSecurity/sc.json": [
		3630,
		54
	],
	"./dataLeakage/sc.json": [
		3631,
		57
	],
	"./ppd/sc.json": [
		3632,
		60
	],
	"./ransomware/sc.json": [
		3633,
		63
	],
	"./socialMedia/sc.json": [
		3634,
		66
	],
	"./whatsApp/sc.json": [
		3635,
		69
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1201;
module.exports = webpackAsyncContext;